module.exports = __webpack_public_path__ + "static/media/icon-users.f44a0210.svg";